import Interceptor from "@/plugins/interceptor.js"

const urlAPI = `${process.env.VUE_APP_API_URL_SECURITY}${process.env.VUE_APP_API_SECURITY}`

const Security = {
  state: {
  },
  actions: {
    authenticate: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/authenticate`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    userCreate: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/userCreate`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    userActivate: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/userActivate`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    beginPasswordRecovery: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/beginPasswordRecovery`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    endPasswordRecovery: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/endPasswordRecovery`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    resendActivationMail: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/resendActivationMail`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    authenticateFacebook: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/authenticateFacebook`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    authenticateGoogle: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/authenticateGoogle`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    authenticateApple: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/authenticateApple`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    beginChangeAppleMail: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/beginChangeAppleMail`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    endChangeAppleMail: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/endChangeAppleMail`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
  }
}

export default Security